enum BillingPendencyGroupTypeEnum {
  ECONOMIC_GROUP = 'economic_group',
  CUSTOMER = 'customer',
  DOCUMENT = 'document',
}

export default BillingPendencyGroupTypeEnum;
